import React from "react";
import { Button } from "react-bootstrap";

// css
import styles from "./Table.module.scss";
import { useNavigate } from "react-router-dom";

// image

const TableLayout = ({ column, data, url, showHeader = true, noDataMsg = "Data not found", state, handleRowClick, height }) => {
  const navigate = useNavigate();
  return (
    <div className="favorite-goal-wrapper table_height" style={{ height: height || "calc(100vh - 220px)"}}>
      <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
        <table className={`${styles.table} table`}>
          {showHeader && (
            <thead>
              <tr className="">
                {column &&
                  column.length > 0 &&
                  column.map((item, key) => (
                    <>
                      <th className="text-dark fw-bold border-0">
                        {item.head}
                      </th>
                    </>
                  ))}
              </tr>
            </thead>
          )}
          <tbody>
            {data && data?.length > 0 ? (
              data.map((data, columnkey) => {
                return (
                  <tr
                    className={`${url && "cursor-pointer"}`}
                    onClick={(e) => {
                      url && navigate(`${url}/${data.id}`, { state });
                      (handleRowClick && typeof handleRowClick == "function") && handleRowClick(data);
                    }}
                  >
                    {column &&
                      column.length > 0 &&
                      column.map((item, key) => {
                        if (item.component) {
                          return (
                            <td className="">
                              {item.component(data, columnkey, data)}
                            </td>
                          );
                        }

                        return (
                          <td className="">{data[item?.accessor] || "--"}</td>
                        );
                      })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={column?.length || 1} className="text-center">
                  {noDataMsg}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableLayout;
